module.exports = __webpack_public_path__ + "static/left-4f27d9eed102c5ed7d9bdd327447fab8.svg";